import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export type NotificationQueryParams = {
  page?: number;
  limit?: number;
  type?: "all" | "follow";
};

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Notification"],
  endpoints: (builder) => ({
    getNotifications: builder.query<any, NotificationQueryParams | void>({
      query: (params) => ({
        url: "notifications",
        method: "GET",
        params: {
          page: params?.page,
          limit: params?.limit,
          type: params?.type,
        },
      }),
      providesTags: ["Notification"],
    }),
    getUnreadNotifications: builder.query({
      query: () => ({
        url: "notifications/unread",
        method: "GET",
      }),
    }),
    readNotification: builder.mutation({
      query: (id: string) => ({
        url: `notifications/${id}/read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notification"],
    }),
    readAllNotification: builder.mutation({
      query: () => ({
        url: "notifications/read-all",
        method: "PATCH",
      }),
    }),
    getInactivity: builder.query<
      { totalInactiveSeconds: number; totalEarnedWhileInactive: number },
      void
    >({
      query: () => ({
        url: "inactivity",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetUnreadNotificationsQuery,
  useReadNotificationMutation,
  useReadAllNotificationMutation,
  useLazyGetInactivityQuery,
} = notificationApi;
